<template>
  <AdminShell
    :page-title="pageTitle"
    :page-subtitle="pageSubtitle"
    active-menu="customer-service"
  >
    <div class="customer-contact-page">
      <div class="page-shell">
        <CustomerContactManager
          :embedded="false"
          :show-back-button="false"
        />
      </div>
    </div>
  </AdminShell>
</template>

<script>
import AdminShell from '@/components/admin/AdminShell.vue'
import CustomerContactManager from '@/components/CustomerContactManager.vue'

export default {
  name: 'CustomerContactPage',
  components: {
    AdminShell,
    CustomerContactManager,
  },
  data() {
    return {
      pageTitle: '客服设置',
      pageSubtitle: '这里保存的是平台账号而不是完整链接，聊天平台会直接打开会话，社媒平台会跳转到账号主页。',
    }
  },
}
</script>

<style scoped>
.customer-contact-page {
  min-height: 0;
}

.page-shell {
  max-width: 1180px;
}
</style>
